import React, { useState, useEffect, useRef } from 'react';
import cN from 'classnames';
import { useDispatch } from 'react-redux';
import * as Tag from '@components/Common/Tag';
import * as Icons from '@components/Common/Icons';
import { I_CallJson, I_SingleGroup, I_TripType } from '@Redux/search/interfaces';
import Tags from '@components/Common/Tags';
import AlertText from '@components/Common/AlertText';
import ContactStaff from '@components/Common/ContactStaff';
import { getIsCompared, handleCompare } from '@utils/compare';
import { handleFavorite, getIsFavorite } from '@utils/favorite';
import { setCallJson } from '@Redux/search/actions';
import styles from '../styles.module.scss';
import { useTranslation } from 'react-i18next';
import GroupTripInfoFlight from '@components/Common/GroupTripInfoFlight';

interface I_Props {
    groupData: I_SingleGroup;
    isFaved?: boolean;
    isLogin?: boolean;
    setFavList: Function;
    favList?: [{ ProductID: string }];
    productUrl: Function;
    callJson: I_CallJson;
}

const SingleList: React.FC<I_Props> = ({
    groupData,
    isFaved,
    isLogin,
    setFavList,
    favList,
    productUrl,
    callJson,
}) => {
    const {
        DirectionList,
        GroupID,
        GoDate,
        HasFlight,
        IsVip,
        IsCruise,
        IsEnsureGroup,
        NormGroupID,
        QuotaSeats,
        StraightLowestPrice,
        StatusText,
        Status,
        StatusUrl,
        TotalSeats,
        TourSource,
        TourBu,
        TourName,
        TripTypeList,
        TagList,
        TourDays,
        TravelType,
        VipOrigPrice,
        TelType,
    } = groupData;
    const [isLightBoxOpen, setIsLightBoxOpen] = useState<boolean>(false);
    const [isFavorite, setIsFavorite] = useState<boolean>(false);
    const [isCompared, setIsCompared] = useState<boolean>(false);
    const [hasClicked, setHasClicked] = useState<boolean>(false);
    const [isContactOpen, setContactOpen] = useState<boolean>(false);
    const dispatch = useDispatch();

    // 新增哪個按鈕被點擊，'compared' | 'favorite' | 'init'
    const typeOfButtonClickedRef = useRef<'compared' | 'favorite' | 'init'>('init');
    const { t } = useTranslation();

    // 比較
    useEffect(() => {
        (async () => {
            await getIsCompared({
                TourDays,
                GoDate,
                NormGroupID,
                NormGroup: TourName,
                GroupID,
                TravelType,
                setIsCompared,
            });
        })();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    // 收藏
    useEffect(() => {
        setIsFavorite(isFaved!);
    }, [isFaved]);

    useEffect(() => {
        if (isLogin) {
            (async () => {
                if (sessionStorage.getItem('waitedForAddedFav') === GroupID) {
                    await handleFavorite({
                        isLogin,
                        isFavorite,
                        TravelType,
                        Price: IsVip ? VipOrigPrice : StraightLowestPrice,
                        TourDays,
                        NormGroup: TourName,
                        NormGroupID,
                        GroupID,
                        GoDate: GoDate.split('(')[0], // 原資料 "2021/05/19(三)" 取日期部分
                        setIsFavorite,
                        setFavList,
                        favList,
                    });
                    sessionStorage.removeItem('waitedForAddedFav');
                    const newFavList = await getIsFavorite('0');
                    setFavList(newFavList);
                }
            })();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isLogin]);

    const reformTripTypeList = TripTypeList.map((trip: I_TripType) => ({
        Name: trip.TypeName,
        Code: trip.TypeCode,
    }));

    const handleHasClicked = (type: 'compared' | 'favorite') => {
        setHasClicked(true);
        typeOfButtonClickedRef.current = type;
    };

    function cantactTel() {
        const callJson = {
            TelType: TelType,
        };
        dispatch(setCallJson(callJson)); // 請洽專員資料
    }

    return (
        <>
            <a
                className={styles.singleCard}
                href={productUrl({ GroupID, TourSource })}
                rel="noreferrer noopener"
            >
                <div className={cN(styles.listControlTag, styles.controlTag)}>
                    <div className={styles.buttons}>
                        <span
                            onClick={async (e) => {
                                e.preventDefault();
                                await handleCompare({
                                    TravelType,
                                    Price: IsVip ? VipOrigPrice : StraightLowestPrice,
                                    TourDays,
                                    NormGroup: TourName,
                                    GoDate: GoDate.split('(')[0], // 原資料 "2021/05/19(三)" 取日期部分
                                    GroupID: GroupID,
                                    NormGroupID,
                                    isCompared,
                                    setIsCompared,
                                });
                                handleHasClicked('compared');
                            }}
                        >
                            <Icons.Compare
                                fill={isCompared ? '#f03742' : '#999'}
                                width={15}
                                height={15}
                            />
                            <span style={isCompared ? { color: '#f03742' } : { color: '#222' }}>
                                比較
                            </span>
                        </span>
                        <span
                            onClick={async (e) => {
                                e.preventDefault();
                                await handleFavorite({
                                    isLogin: isLogin!,
                                    isFavorite,
                                    TravelType,
                                    Price: IsVip ? VipOrigPrice : StraightLowestPrice,
                                    TourDays,
                                    NormGroup: TourName,
                                    NormGroupID,
                                    GroupID,
                                    GoDate: GoDate.split('(')[0], // 原資料 "2021/05/19(三)" 取日期部分
                                    setIsFavorite,
                                    setFavList,
                                    favList,
                                });
                                handleHasClicked('favorite');
                            }}
                        >
                            {isFavorite ? (
                                <Icons.FillHeart fill="#f03742" width={13} height={13} />
                            ) : (
                                <Icons.HollowHeart fill="#999" width={13} height={13} />
                            )}
                            <span style={isFavorite ? { color: '#f03742' } : { color: '#222' }}>
                                收藏
                            </span>
                        </span>
                    </div>
                </div>
                <div className={styles.singleHeader}>
                    <div className={styles.kindTag}>
                        {/* <Tag.Featured text="雄獅推薦" /> */}
                        {IsVip && <Tag.Featured text="會員限購" />}
                        {IsCruise && <Tag.Featured text="郵輪優先選房號" />}
                    </div>
                    {TourBu && <div className={styles.title}>聯營商品:{TourBu}</div>}
                </div>
                <div className={styles.singleBody}>
                    <div className={styles.tirpInfo}>
                        <span className={styles.caption}>{TourName}</span>
                        <Tags TripTypeList={reformTripTypeList} TagList={TagList} />
                    </div>
                    <div className={styles.date}>
                        <div data-title-m="日期：">
                            {GoDate}
                            <span>{TourDays}天</span>
                        </div>
                        <div data-title-m={`${t('ProductID')}：`} className={styles.num}>
                            {GroupID}
                        </div>
                    </div>
                    <div className={styles.flightInfo}>
                        <div data-title-m="航空：" data-title-pc="">
                            {HasFlight ? (
                                <div
                                    className={cN(styles['flightInfoData'])}
                                    onClick={(e) => {
                                        e.preventDefault();
                                        setIsLightBoxOpen(true);
                                    }}
                                >
                                    航班資訊
                                </div>
                            ) : (
                                <span>一一</span>
                            )}
                        </div>
                    </div>
                    <div className={styles.sell}>
                        {IsEnsureGroup && <div className={styles.isDone}>{t('IsEnsureGroup')}</div>}

                        <div data-title-m={`機位：${t('seats')}`} data-title-pc={`${t('seats')} `}>
                            {TotalSeats}
                        </div>
                        <div data-title-m="可賣：" data-title-pc="可賣 ">
                            {QuotaSeats}
                        </div>
                    </div>
                    <div className={styles.priceWrap}>
                        <div className={styles.price}>
                            {IsVip && (
                                <div className={styles.origPrice}>
                                    原價：<span data-unit="人/起">{VipOrigPrice}</span>
                                </div>
                            )}

                            <div
                                data-currency={Status === 6 ? null : 'TWD'}
                                data-unit={Status === 6 ? null : '人/起'}
                                className={cN(styles.sellPrice, {
                                    [`${styles.upcoming}`]: Status === 6,
                                })}
                            >
                                {Status === 6 ? '近期上架' : StraightLowestPrice}
                            </div>
                        </div>
                        <span
                            // href={StatusUrl}
                            onClick={(e) => {
                                e.preventDefault();
                                cantactTel();
                                Status === 4 ? setContactOpen(true) : window.open(StatusUrl);
                            }}
                            className={cN(styles.orderBtn, {
                                [`${styles.close}`]: Status == 3 || Status == 5,
                            })}
                        >
                            {StatusText}
                        </span>
                    </div>
                </div>

                {/* {點擊提醒視窗} */}
                {hasClicked && (
                    <AlertText
                        isCompared={isCompared}
                        isFavorite={isFavorite}
                        typeOfAlert={typeOfButtonClickedRef.current}
                        setHasClicked={setHasClicked}
                    />
                )}
            </a>

            {/* 請洽專員光箱 */}
            <ContactStaff
                open={isContactOpen}
                ToggleLightBox={() => {
                    setContactOpen(false);
                }}
                callJson={callJson}
                TelType={TelType}
                GroupInfo={groupData}
            />

            {/* 航班資訊光箱 */}
            {DirectionList[0]?.FlightList && (
                <GroupTripInfoFlight
                    directionList={DirectionList}
                    open={isLightBoxOpen}
                    ToggleLightBox={() => setIsLightBoxOpen(false)}
                />
            )}
        </>
    );
};

export default SingleList;
